if (!customElements.get('cart-popup')) {
  customElements.define('cart-popup', class CartPopup extends HTMLElement {
    constructor() {
      super();
      
      this.minItems = parseInt(this.dataset.minItems) || 0;
      this.minPrice = parseInt(this.dataset.minPrice) || 0;
      
      this.closeButton = this.querySelector('.cart-popup__close-button');
      this.overlay = this.querySelector('.cart-popup__overlay');

      // Initialize event listeners
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this));

    }

    connectedCallback() {
      // Listen for our custom event when products are added to cart
      document.addEventListener('product:added-to-cart', (event) => {
        this.checkCartAndShowPopup();
      });
      
      // Check sessionStorage to see if popup was already shown in this session
      const popupShown = sessionStorage.getItem(`cart-popup-shown-${this.id}`);
      if (popupShown) {
        return;
      }
    }
    
    async checkCartAndShowPopup(cartData = null) {
      try {
        // Use provided cart data if available, otherwise fetch it
        let cart;
        if (cartData && cartData.cartData) {
          cart = cartData.cartData;
        } else {
          const response = await fetch('/cart.js');
          if (!response.ok) throw new Error('Failed to fetch cart');
          cart = await response.json();
        }
        
        // Ensure cart data is valid
        if (!cart) {
          console.error('Invalid cart data');
          return;
        }

        // Check if conditions are met
        const totalPrice = cart.total_price || 0;
        
        // Count unique products instead of total items
        let uniqueProductCount = 0;
        if (cart.items && Array.isArray(cart.items)) {
          // Use a Set to track unique product IDs
          const uniqueProductIds = new Set();
          cart.items.forEach(item => {
            uniqueProductIds.add(item.product_id);
          });
          uniqueProductCount = uniqueProductIds.size;
        }

        // Check if we're on the same page as the button link
        const linkBlock = this.querySelector('.cart-popup__link a');
        if (linkBlock) {
          const linkUrl = new URL(linkBlock.href, window.location.origin);
          const currentUrl = new URL(window.location.href);
          
          // Don't show popup if we're already on the target page
          if (linkUrl.pathname === currentUrl.pathname) {
            return;
          }
          
          // Don't show popup if the linked product is already in cart
          const productHandle = this.getProductHandleFromUrl(linkUrl.pathname);
          if (productHandle && this.isProductInCart(cart, productHandle)) {
            return;
          }
        }
        
        if ((this.minItems > 0 && uniqueProductCount >= this.minItems) ||
            (this.minPrice > 0 && totalPrice >= this.minPrice)) {
          this.show();
        }
      } catch (error) {
        console.error('Error checking cart:', error);
      }
    }
    
    show() {
      // Don't show if already shown in this session
      const popupShown = sessionStorage.getItem(`cart-popup-shown-${this.id}`);
      if (popupShown) {
        return;
      }
      
      // Show the popup
      this.classList.add('active');
      document.body.classList.add('cart-popup-open');
      
      // Mark as shown in this session
    }
    
    close() {
      sessionStorage.setItem(`cart-popup-shown-${this.id}`, 'true');
      this.classList.remove('active');
      document.body.classList.remove('cart-popup-open');
    }

    getProductHandleFromUrl(pathname) {
      // Extract product handle from URL like /products/product-handle
      const match = pathname.match(/\/products\/([^\/\?#]+)/);
      return match ? match[1] : null;
    }

    isProductInCart(cart, productHandle) {
      // Check if cart.items exists before using some()
      if (!cart || !cart.items) {
        return false;
      }

      // Check if any item in the cart has the same handle as the target product
      return cart.items.some(item => {
        const itemUrl = new URL(item.url, window.location.origin);
        const itemHandle = this.getProductHandleFromUrl(itemUrl.pathname);
        return itemHandle === productHandle;
      });
    }
  });
}
